<template>
  <ContentPage title="DMCA &amp; Copyright Policy" page="dmca" updated="September 15, 2026">
    <p>
      SnapInsta respects the intellectual property rights of content creators and copyright owners.
    </p>
    <p>
      SnapInsta does not claim ownership of content available through third-party platforms.
    </p>
    <p>
      If you believe that copyrighted content has been made available through our service without
      proper authorization, you may contact us with the relevant information.
    </p>

    <h2>Copyright Complaints</h2>
    <p>Please include the following information in your copyright complaint:</p>
    <ul>
      <li>Your full name and contact information</li>
      <li>Identification of the copyrighted work</li>
      <li>
        The URL or other information that allows us to identify the relevant content
      </li>
      <li>
        A description explaining why you believe the content infringes your copyright
      </li>
      <li>
        A statement confirming that the information provided is accurate and that you are authorized
        to act on behalf of the copyright owner, where applicable
      </li>
    </ul>
    <p>
      Please send copyright-related requests through our
      <router-link to="/contact/">Contact Us</router-link> page.
    </p>
    <p>
      After receiving a valid complaint, we may review the request and take appropriate action where
      applicable.
    </p>

    <h2>Third-Party Content</h2>
    <p>
      SnapInsta does not host or claim ownership of Instagram content submitted by users.
    </p>
    <p>
      Users are responsible for the content they choose to download and use.
    </p>
  </ContentPage>
</template>

<script>
import ContentPage from '@/components/ContentPage.vue';

export default {
  name: 'DmcaPage',
  components: {
    ContentPage,
  },
};
</script>
